import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { FiX, FiCpu, FiExternalLink } from 'react-icons/fi';
import styles from './BookDemoModal.module.css';

const CALENDLY_URL = "https://calendly.com/sanjaysoni-provaantech/vendor-empanelment-discussion-provaantech";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

const BookDemoModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    const handleCalendlyEvent = async (e) => {
      if (e.origin === "https://calendly.com" && e.data && e.data.event === "calendly.event_scheduled") {
        console.log("Calendly event scheduled:", e.data.payload);
        const payload = e.data.payload || {};
        const invitee = payload.invitee || {};
        const event = payload.event || {};

        const name = invitee.name || (invitee.first_name ? `${invitee.first_name} ${invitee.last_name || ''}`.trim() : 'Calendly Booking');
        const email = invitee.email || 'N/A';
        const date = event.start_time || new Date().toISOString();
        const phone = invitee.text_reminder_number || invitee.phone || 'Calendly Sync';
        const message = `Scheduled directly via Calendly Widget`;

        try {
          const res = await fetch(`${API_BASE_URL}/api/demo`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name,
              email,
              phone,
              message,
              date,
              solutionInterest: 'SaleSense AI Platform (Calendly)',
              turnstileToken: 'calendly-verified-token'
            })
          });

          if (res.ok) {
            toast.success('Calendly booking synced to Admin Dashboard!');
          }
        } catch (err) {
          console.error('Failed to sync Calendly event to SaleSense backend:', err);
        }
      }
    };

    window.addEventListener('message', handleCalendlyEvent);
    return () => window.removeEventListener('message', handleCalendlyEvent);
  }, []);

  if (!isOpen) return null;

  const embedUrl = `${CALENDLY_URL}?embed_domain=${encodeURIComponent(window.location.hostname || 'localhost')}&embed_type=Inline&primary_color=38bdf8`;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
        <div className={styles.glowGradient} />

        <div className={styles.header}>
          <div>
            <div className={styles.badgeTag}>
              <FiCpu size={14} /> SaleSense AI Platform Demo
            </div>
            <h2 className={styles.headerTitle}>Schedule Autonomous AI Walkthrough</h2>
            <div className={styles.headerSub}>
              Select your preferred date & time for a personalized 1-on-1 session.
            </div>
          </div>

          <div className={styles.headerActions}>
            <a 
              href={CALENDLY_URL} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.externalBtn}
              title="Open Calendly in new tab"
            >
              Open in new tab <FiExternalLink size={14} />
            </a>
            <button onClick={onClose} className={styles.closeBtn} aria-label="Close">
              <FiX size={20} />
            </button>
          </div>
        </div>

        <div className={styles.iframeContainer}>
          <iframe
            src={embedUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            title="Schedule SaleSense AI Demo via Calendly"
            style={{ border: 'none', width: '100%', height: '100%', minHeight: '550px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default BookDemoModal;
